import { fetchWithErrorHandling, buildGetOptions } from "../FetchUtils";
import { useAuthUser } from "react-auth-kit";
import { useContext } from "react";
import { AppContext } from "utils/AppContext";
import { getBaseURL } from "utils/Environment";

export const list = async (accessToken: string, baseURL: string) => {
  return fetchWithErrorHandling(baseURL + "v1/logging/list", buildGetOptions(accessToken));
};

export const load = async (accessToken: string, baseURL: string, logName: string) => {
  return fetchWithErrorHandling(baseURL + `v1/logging/load/${logName}`, buildGetOptions(accessToken), false, true);
};

export const loadFrom = async (accessToken: string, baseURL: string, logName: string, timestamp: number) => {
  return fetchWithErrorHandling(
    baseURL + `v1/logging/load/${logName}/from/${timestamp}`,
    buildGetOptions(accessToken),
    false,
    true,
  );
};

export const listEnvironmentStreams = async (accessToken: string, baseURL: string, environmentName: string) => {
  return fetchWithErrorHandling(baseURL + `v1/logging/environment/${environmentName}`, buildGetOptions(accessToken));
};
export const listEnvironmentEventLogs = async (
  accessToken: string,
  baseURL: string,
  environmentName: string,
  streamName: string,
  nextToken: string | null,
  limit: number,
) => {
  return fetchWithErrorHandling(
    baseURL +
      `v1/logging/environment/${environmentName}/${streamName}?limit=${limit}` +
      (nextToken ? `&nextToken=${nextToken}` : ``),
    buildGetOptions(accessToken),
  );
};

export const useLoggingService = () => {
  const authUser = useAuthUser();
  const accessToken = authUser()?.access_token;
  const appContext = useContext(AppContext);

  return {
    list: () => list(accessToken, getBaseURL(appContext)),
    load: (logName: string) => load(accessToken, getBaseURL(appContext), logName),
    loadFrom: (logName: string, timestamp: number) => loadFrom(accessToken, getBaseURL(appContext), logName, timestamp),
    listEnvironmentStreams: (environmentName: string) =>
      listEnvironmentStreams(accessToken, getBaseURL(appContext), environmentName),
    listEnvironmentEventLogs: (environmentName: string, streamName: string, nextToken: string | null, limit: number) =>
      listEnvironmentEventLogs(accessToken, getBaseURL(appContext), environmentName, streamName, nextToken, limit),
  };
};
